import React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import CreateDiscounts from './CreateDiscounts';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.booking.list,
  height: '100%',
  padding: '2rem 1rem 1rem 1rem',
  overflow: 'auto',

  [theme.breakpoints.up('xs')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('md')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('lg')]: {
    height: '67.3vh'
  }
}));

const Discounts = ({
  participants = [],
  setIsFormValid = () => {},
  setParticipants = () => {},
  selectedSessions = [],
  discountOptions = {}
}) => {
  return (
    <>
      <StyledBox>
        <CreateDiscounts
          participants={participants}
          setParticipants={setParticipants}
          setIsFormValid={setIsFormValid}
          selectedSessions={selectedSessions}
          discountOptions={discountOptions}
        />
      </StyledBox>
    </>
  );
};
export default Discounts;
